import { z } from 'zod'

export const childSchema = z.object({
  first_name: z.string().min(1, 'First name is required').max(100),
  // Required: gym documents signed for a child name them, and a first name
  // alone does not identify anyone on a consent form.
  last_name: z.string().trim().min(1, 'Last name is required').max(100),
  // Required: whether a parent must sign a gym's child documents depends on
  // the child being under 18, which is unknowable without it.
  birth_date: z
    .string({ required_error: 'Birth date is required' })
    .min(1, 'Birth date is required')
    .refine(
      (v) => {
        const d = new Date(v)
        if (isNaN(d.getTime())) return false
        return d <= new Date()
      },
      { message: 'Birth date must be a valid date in the past' },
    ),
  // Optional so an installed app from before this field existed still saves.
  // Competition categories need it, and a child with a login of their own
  // cannot set it themselves.
  gender: z.enum(['male', 'female']).nullable().optional(),
})

export type ChildInput = z.infer<typeof childSchema>

// Lowercased so the address compares equal to whatever Auth0 later reports for
// the account that signs up with it.
export const childInviteSchema = z.object({
  email: z.string().trim().toLowerCase().email('Enter a valid email address').max(254),
})

export type ChildInviteInput = z.infer<typeof childInviteSchema>
